import {
  DocumentReference,
  INamedDocument,
  ISoftDelete,
  Timestamp,
} from '@principle-theorem/shared';
import { IAutomationScopeData } from '../automation/automation';
import { IBrand } from '../brand';
import { IPatient } from '../patient/patient';
import { IMarketingCampaign } from './campaign';
import { IMarketingCampaignRun } from './campaign-run';
import { IMarketingCampaignStep } from './campaign-step';
import { IMarketingCampaignStepConversion } from './campaign-step-conversion';

export enum MarketingCampaignEntryStatus {
  Preview = 'preview',
  Approved = 'approved',
  Pending = 'pending',
  Active = 'active',
  Failed = 'failed',
  Unsubscribed = 'unsubscribed',
  Unenrolled = 'unenrolled',
  Completed = 'completed',
  Converted = 'converted',
  Paused = 'paused',
  PausedForPayment = 'pausedForPayment',
}

export enum MarketingCampaignEntryCollection {
  StepConversions = 'stepConversions',
  Engagements = 'engagements',
  Logs = 'logs',
}

export enum CampaignEntryPauseReason {
  InsufficientFunds = 'insufficientFunds',
  UserInitiated = 'userInitiated',
  SystemPause = 'systemPause',
}

// TODO: Each patient that's added to the campaign will have the campaign steps
// lined up to run. If they unsubscribe between steps, we need a way of ensuring
// that no further steps complete. The steps will also need a cloud task on a
// per-patient basis, even if it's a single run. This ensures that we can run a
// campaign and not rely on a cloud resource that needs to handle an unscalable
// amount of data.
export interface IMarketingCampaignEntry extends ISoftDelete {
  brandRef: DocumentReference<IBrand>;
  campaignRef: DocumentReference<IMarketingCampaign>;
  campaignRunRef: DocumentReference<IMarketingCampaignRun>;
  patient: INamedDocument<IPatient>;
  normalisedEmail?: string;
  normalisedMobile?: string;
  hasDuplicateEmail?: boolean;
  hasDuplicateMobile?: boolean;
  status: MarketingCampaignEntryStatus;
  scopeLabel: string;
  scopeData: IAutomationScopeData;
  steps: DocumentReference<IMarketingCampaignStep>[];
  currentStep?: DocumentReference<IMarketingCampaignStepConversion>;
  conversionUid: string;
  errorMessage?: string;
  pauseReason?: CampaignEntryPauseReason;
  pausedAt?: Timestamp;
  resumedAt?: Timestamp;
  startedAt?: Timestamp;
  enrolledByCampaignRunRef?: DocumentReference<IMarketingCampaignRun>;
  // Phase 3: Cost tracking fields
  estimatedTotalCost?: number;
  incurredCost?: number;
  billingAlertAcknowledged?: boolean;
  // TODO: Aggregate what step they're up to, and their conversion status
}

export interface ICampaignEntryReportResult {
  patientName: string;
  patientEmail: string;
  patientMobile: string;
  patientRef: DocumentReference<IPatient>;
  marketingOptIn: boolean;
  scopeLabel: string;
  scopeData: IAutomationScopeData;
}
